import {
  LtiAdvantageFormValues,
  LtiAdvantagePayload,
} from 'types/LtiAdvantage';
import { AGS_SCOPE_MAPPING } from 'constants/ltiScopes';

/**
 * Builds the LTI Advantage payload object from form values
 * @param values - Form values containing LTI Advantage settings
 * @returns LTI Advantage payload object for API
 */
export const buildLtiAdvantagePayload = (
  values: LtiAdvantageFormValues
): LtiAdvantagePayload => {
  const advantage: LtiAdvantagePayload = {};

  // Add NRPS
  advantage.nrps = { enabled: values.nrpsEnabled };

  // Add Deep Linking
  advantage.deepLinking = { enabled: values.deepLinkingEnabled };

  // Add AGS
  if (values.agsEnabled) {
    // Auto-select all scopes except 'lineitem' which is always disabled
    const agsScopes = [
      AGS_SCOPE_MAPPING.score,
      AGS_SCOPE_MAPPING.lineitemReadonly,
      AGS_SCOPE_MAPPING.resultReadonly,
    ];

    advantage.ags = {
      enabled: true,
      scopes: agsScopes,
    };
  } else {
    advantage.ags = { enabled: false, scopes: [] };
  }

  return advantage;
};

/**
 * Parses LTI Advantage data from API response to form values
 * @param advantageData - LTI Advantage data from API
 * @returns Form values for LTI Advantage fields
 */
export const parseLtiAdvantageData = (
  advantageData?: LtiAdvantagePayload
): LtiAdvantageFormValues => {
  return {
    nrpsEnabled: advantageData?.nrps?.enabled || false,
    deepLinkingEnabled: advantageData?.deepLinking?.enabled || false,
    agsEnabled: advantageData?.ags?.enabled || false,
  };
};
